import { combineReducers } from 'redux';
import form from './form';
import pageLayout from './page-layout';
import search from './search';
import ROItemSearch from './ro-item-search';
import ROPicklistSearch from './ro-picklist-search';
import reports from './reports';

export default combineReducers({
  form,
  pageLayout,
  search,
  ROItemSearch,
  ROPicklistSearch,
  reports
});
